import { MachineContext } from 'contexts/machine.context';
import { useContext, useEffect } from 'react';
import useListLibraryStore from 'stores/use-list-library-store';

const useSyncRecentLists = () => {
  const { machine } = useContext(MachineContext);

  const activeList = useListLibraryStore((s) => s.activeList);
  const rawLists = useListLibraryStore((s) => s.rawLists);

  // keep track of the most recently activated pitch lists
  useEffect(() => {
    if (!activeList?._id) {
      return;
    }

    // remove it from the recent list if it already existed (e.g. further down)
    const recent = useListLibraryStore
      .getState()
      .recentListIDs.filter((id) => id !== activeList._id);

    // place it at the top of the recent list
    recent.splice(0, 0, activeList._id);

    // truncate the recent list
    useListLibraryStore.setState({
      recentListIDs: recent.filter((_, i) => i < 5),
    });
  }, [activeList?._id]);

  // automatically clean up recent IDs and the folders from rawLists before setting lists for use */
  useEffect(() => {
    /** e.g. a list is deleted, should not show up in recent lists anymore */
    const rawIDs = rawLists.map((l) => l._id);

    useListLibraryStore.setState({
      recentListIDs: useListLibraryStore
        .getState()
        .recentListIDs.filter((id) => rawIDs.includes(id)),
    });
  }, [rawLists, machine.machineID]);
};

export default useSyncRecentLists;
